import axios from 'axios';
const URL_API_HORARIOTIENDA = process.env.VUE_APP_URL_API_HORARIOTIENDA;

export class HorariotiendaApiService {

  getHorarioTiendaByOpuid(opuid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_HORARIOTIENDA}getHorariotiendaByOpuid/${opuid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
  createHorarioTienda(horario) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_HORARIOTIENDA}createHorariotienda`;
    return axios
      .post(url, horario ,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
}
